<template>
  <b-modal
    v-model="visible"
    :title="isEdit ? 'Edit Voice Prompt' : 'Add Voice Prompt'"
    @ok="handleSave"
    :ok-disabled="!isValid"
    :ok-title="isEdit ? 'Save Changes' : 'Add Voice Prompt'"
  >

    <b-form-group>
      <b-form-checkbox v-model="isActive" switch>
        {{ isActive ? 'Enabled' : 'Disabled' }}
      </b-form-checkbox>
    </b-form-group>

    <b-form-group class="commandTextarea" label="Voice prompt content">
      <b-form-textarea v-model="content"
        rows="6"
        max-rows="12" 
        placeholder="Content of the voice prompt"
      />
    </b-form-group>

    <hr />

    <p class="mb-2">Now record/edit the phrase that should trigger this voice prompt:</p>
    <MdCommandSpeechCapture
      :initial-trigger="trigger"
      @update:trigger="trigger = $event"
    />
  </b-modal>
</template>

<script>
//import { EventBus } from '@/event-bus.js';
import LocalStorage from '@/services/storage.service';
export default {
  name: 'MdCommandEditorModal',
  props: {
    value: Boolean,
    editingCommand: Object
  },
  data() {
    return {
      id: LocalStorage.getUserId(),
      content: this.editingCommand.content || '',
      trigger: this.editingCommand.phrase || '',
      isActive: this.editingCommand.recID ? !!this.editingCommand.isActive : true
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(val) { this.$emit('input', val); }
    },
    isEdit() {
      return !!this.editingCommand.recID;
    },
    isValid() {
      return this.content.trim() && this.trigger.trim();
    }
  },
  watch: {
    editingCommand: {
      immediate: true,
      handler(cmd) {
        this.content = cmd?.content || '';
        this.trigger = cmd?.phrase || '';
        this.isActive = cmd?.recID ? !!cmd?.isActive : true;
      }
    }
  },
  methods: {
    handleSave(e) {
      if (!this.isValid) {
        e.preventDefault();
        return;
      }
      this.$emit('saveCommand', {
        recID: this.editingCommand.recID || null,
        userId: this.id,
        content: this.content,
        phrase: this.trigger,
        phrase_normalized: this.trigger.toLowerCase(),
        isActive: this.isActive,
        isEdit: this.isEdit,
      });
    },
  },
};
</script>

<style scoped>

.commandTextarea {
  border: 1px solid #020b14;
  border-radius: 0.25rem;
}
</style>